import { render } from "./ReportsStaff.vue?vue&type=template&id=37a221ca"
import script from "./ReportsStaff.vue?vue&type=script&lang=js"
export * from "./ReportsStaff.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__